export const SettingsActionTypes = {
  SET_LANGUAGE: '[Settings] Set language',
}
